// extracted by mini-css-extract-plugin
export default {"title":"integrated_title__NtK1H","integratedAdWrapper":"integrated_integratedAdWrapper__B5b-f"};